/* Model */
class TicketResolutionModel extends App.Models.BaseModel {
  modelUrl = 'TicketResolution';
}

App.Models.TicketResolution = TicketResolutionModel;

/* Collection */
class TicketResolutionCollection extends App.Collections.BaseCollection {
  url = 'TicketResolution';
  model = App.Models.TicketResolution;
}

App.Collections.TicketResolutions = TicketResolutionCollection;

/* Router */
class TicketResolutionRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'TicketResolution';
    const model = App.Models.TicketResolution;
    const collectionClass = App.Collections.TicketResolutions;

    super(entityName, model, collectionClass);
  }
}

App.Routers.TicketResolution = TicketResolutionRouter;